import { useDispatch, useSelector } from 'react-redux';

import { dismissSnackbar, selectSnackbar } from './services';
import { AlertStyled, SnackbarStyled } from './SnackbarStyled';
import { AUTO_HIDE_DURATION, SNACKBAR_ICONS } from './utils';

export type SnackbarPosition = 'bottom' | 'aboveMenu' | 'aboveNativeAuthDialog';
export type SnackbarSeverity = 'error' | 'info' | 'success' | 'warning';

export const Snackbar = () => {
  const {
    severity,
    isOpen,
    message,
    position,
    disableAutoHide,
    zIndex,
    ...props
  } = useSelector(selectSnackbar);
  const dispatch = useDispatch();

  const handleClose = (_: React.SyntheticEvent | Event, reason?: string) =>
    reason !== 'clickaway' && dispatch(dismissSnackbar());

  return (
    <SnackbarStyled
      data-testid="snackbar"
      open={isOpen}
      autoHideDuration={disableAutoHide ? null : AUTO_HIDE_DURATION}
      onClose={handleClose}
      position={position}
      $zIndex={zIndex}
    >
      <AlertStyled
        icon={SNACKBAR_ICONS[severity as SnackbarSeverity]}
        onClose={handleClose}
        variant="filled"
        color={severity}
        {...props}
      >
        {message}
      </AlertStyled>
    </SnackbarStyled>
  );
};
